import { Button } from '@unified-lk/ui'
import { formatDateTime, formatStatusLabel } from '../../lib/format'
import type { StaffPatientCommentsData } from '../../types/plans'
import {
  workspaceActionsClassName,
  workspaceBadgeClassName,
  workspaceCardClassName,
  workspaceEmptyClassName,
  workspaceGridClassName,
  workspaceHeaderClassName,
  workspaceKickerClassName,
  workspaceMetricClassName,
  workspaceMutedTextClassName,
  workspacePanelClassName,
  workspaceSummaryGridClassName,
} from '../workspaceStyles'

export function PatientCommentsSection({
  data,
  loading,
  error,
  onRetry,
}: {
  data: StaffPatientCommentsData | null
  loading: boolean
  error: string | null
  onRetry: () => void
}) {
  if (loading && !data) {
    return <div className={workspaceEmptyClassName}><p>Загружаем комментарии к приемам...</p></div>
  }

  if (!data) {
    return <div className={workspaceEmptyClassName}><p>{error ?? 'Раздел комментариев пока недоступен.'}</p></div>
  }

  return (
    <div className={workspaceGridClassName}>
      <section className={workspacePanelClassName}>
        <div className={workspaceHeaderClassName}>
          <div className="grid gap-2">
            <p className={workspaceKickerClassName}>Appointment Comments</p>
            <h2 className="text-2xl font-semibold text-slate-900">Комментарии к приемам</h2>
            <p className={workspaceMutedTextClassName}>
              Лента прошлых и ближайших приемов с doctor notes и статусом заполнения комментария.
            </p>
            {data.sources ? <p className="text-xs leading-5 text-slate-500">Source: `{data.sources.comments}`</p> : null}
          </div>
          <div className={workspaceActionsClassName}>
            <Button variant="secondary" type="button" onClick={onRetry}>Обновить</Button>
          </div>
        </div>

        <div className={workspaceSummaryGridClassName}>
          <div className={workspaceMetricClassName}><span className="text-[13px] text-slate-500">Всего</span><strong className="text-slate-900">{data.summary.total}</strong></div>
          <div className={workspaceMetricClassName}><span className="text-[13px] text-slate-500">С комментарием</span><strong className="text-slate-900">{data.summary.with_comment}</strong></div>
          <div className={workspaceMetricClassName}><span className="text-[13px] text-slate-500">Без комментария</span><strong className="text-slate-900">{data.summary.without_comment}</strong></div>
        </div>
      </section>

      {error ? <div className="rounded-[20px] bg-rose-50 px-4 py-3 text-sm leading-6 text-rose-700"><p>{error}</p></div> : null}

      <section className="grid gap-4 xl:grid-cols-2">
        {data.comments.map((entry) => (
          <article key={entry.id} className={workspaceCardClassName}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <strong className="block text-lg text-slate-900">{entry.patient_name}</strong>
                <p className={workspaceMutedTextClassName}>{entry.service_name}</p>
              </div>
              <span className={workspaceBadgeClassName(entry.has_comment)}>
                {entry.has_comment ? 'Есть комментарий' : 'Пусто'}
              </span>
            </div>
            <div className="flex flex-wrap gap-3 text-sm leading-6 text-slate-600">
              <span>{entry.doctor_name}</span>
              <span>{formatStatusLabel(entry.status)}</span>
              <span>{formatDateTime(entry.date)}</span>
            </div>
            <p className={workspaceMutedTextClassName}>{entry.comment || 'Комментарий не заполнен.'}</p>
          </article>
        ))}
      </section>
    </div>
  )
}
